import * as React from 'react';
import styled from 'styled-components';

import Drawer from 'components/common/Drawer';
import { Icon, IfPermitted } from 'components/common';
import { Button } from 'components/bootstrap';
import { Row } from 'common/components/layout-styles';
import EventProcedureDetailsView from 'security-app/components/SecurityEvents/EventProcedures/EventProcedureDetailsView';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

import EventProcedureModal from '../EventProcedureModal';

const Title = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.2;
`;

const RoundButton = styled(Button)`
  border-radius: 4px;
`;

type Props = {
  eventProcedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>;
  onClose: () => void;
};

function EventProcedureDetailsDrawer({ eventProcedure, onClose }: Props) {
  const [show, setShow] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);

  const onCloseEditModal = () => {
    setShowEditModal(false);
  };

  return (
    <>
      <Drawer
        opened={show}
        onClose={onClose}
        size="lg"
        position="right"
        overlayProps={{ zIndex: '1030' }}
        title={
          <Row $align="center" $justify="space-between" $width="100%">
            <Title title={eventProcedure.title || 'No title set'}>{eventProcedure.title || <i>No title set</i>}</Title>
            <IfPermitted permissions={[`event_procedures:edit:${eventProcedure.id}`]}>
              <RoundButton bsSize="sm" onClick={() => setShowEditModal(true)}>
                <Row $align="center" $gap="xs">
                  <Icon name="edit_square" />
                  <span>Edit</span>
                </Row>
              </RoundButton>
            </IfPermitted>
          </Row>
        }>
        <EventProcedureDetailsView eventProcedure={eventProcedure} withAssocEntities />
      </Drawer>
      {showEditModal && <EventProcedureModal onClose={onCloseEditModal} eventProcedureId={eventProcedure.id} />}
    </>
  );
}

export default EventProcedureDetailsDrawer;
